import FiltersModal from './FiltersModal';

export default FiltersModal;
